<div class="action-arrow__content">
	<a class="action-icon action-icon-active" (click)="onShowProductModal()">
		{{ cellValue.productName }}
	</a>
</div>
